/* eslint-disable @typescript-eslint/naming-convention */
import { Pagination, Swiper } from 'swiper';

class ReviewsSWiper {
  constructor(element) {
    if (!(element instanceof HTMLElement)) {
      throw new TypeError('Invalid element');
    }

    this.element = element;
    this.pagination = this.element.querySelector('.swiper-pagination');

    this.initSwiper();
  }

  initSwiper() {
    this.swiper = new Swiper(this.element, {
      modules: [Pagination],
      allowTouchMove: true,
      slidesPerView: 1,
      spaceBetween: 0,
      slidesPerGroup: 1,
      loop: true,
      pagination: {
        el: this.pagination,
        clickable: true,
      },
      breakpoints: {
        1200: {
          slidesPerView: 3,
          spaceBetween: 30,
          slidesPerGroup: 3,
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 30,
          slidesPerGroup: 2,
        },
      },
    });
  }
}

export default ReviewsSWiper;
